<template>
  <div class="wrapper">
    <fo-workPlaceholder v-if="loading"></fo-workPlaceholder>
    <div v-else>
      <fo-noData v-if="worksList.length === 0"></fo-noData>
      <el-row v-else :gutter="80" :style="screenWidth>768?'':'padding-left: 50px;padding-right: 50px;'">
        <el-col v-for="(n,idx) in worksList" :key="idx" :span="screenWidth<=768?24:12">
          <div :style="screenWidth>768?offsetBottom(idx):''" class="work-items-item pr lf-0">
            <div @click="viewItem(n)" v-observe-visibility="visibilityChanged" :index="idx" :class="screenWidth>1200?'transition-wrap':''"
            class="graylight-bg pr ht-100x">
              <div
                :style="{backgroundImage: 'url(' + n.work_poster + ')'}"
                style="height:50%;"
                class="wi-100x silverdark-bg centerimage transition-slow pa bm-0 lf-0"></div>
            </div>
            <div class="dis-ib pa lf--30 works-items-title-box">
              <div class="work-items-title serif cur-p">{{n.work_title}}</div>
              <div>
                <span class="work-items-tags op-8">{{n.work_subtitle}}</span>
              </div>
            </div>
            <span v-if="idx === worksList.length-1">
              <div class="wi-100x" v-show="worksList.length !== total">
                <div @click="loadMore" v-if="screenWidth>768" class="ta-c transition-slow pr tp-100 mt-10">
                  <span class="dis-ib work-items-more serif" :class="screenWidth<=1200?'title-default-text':'hover-text'">
                    {{info.work_more}}
                    <div v-if="screenWidth>992" class="default-font dis-ib fs-14 lh-14 pr lf--6" :class="screenWidth<=1200?'':'hover-text-more'">更<br>多</div>
                    <div v-else class="default-font dis-ib fs-15 pr lf--2">
                      更多
                    </div>
                  </span>
                </div>
              </div>
            </span>
          </div>
        </el-col>
      </el-row>
      <div @click="loadMore" v-if="screenWidth<=768&&worksList.length !== total" class="ta-c transition-slow pb-100">
        <span class="dis-ib work-items-more serif" :class="screenWidth<=1200?'title-default-text':'hover-text'">
          {{info.work_more}}
          <div class="default-font dis-ib fs-15 pr lf--2">
            更多
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'workItems',
  computed: {
    ...mapGetters([
      'scrollHeight',
      'textInfo',
      'screenWidth'
    ])
  },
  data () {
    return {
      loading: true,
      worksList: [],
      info: {},
      total: 0,
      pageNum: 1
    }
  },
  watch: {
    scrollHeight (val) {
      this.offsetBottom()
    },
    textInfo (val) {
      if (val) {
        this.info = this.$.s2o(val)
        this.$.s('textInfo', val)
      }
    }
  },
  mounted () {
    this.readWorks(true)
    if (this.$.g('textInfo')) {
      this.info = this.$.s2o(this.$.g('textInfo'))
    }
  },
  methods: {
    /*
    * 加载更多
    */
    loadMore () {
      this.pageNum += 1
      this.readWorks(false)
    },
    /*
    * 查询作品
    */
    readWorks (isFirst) {
      if (isFirst) {
        this.loading = true
      }
      this.get({
        url: 'webWorksRead',
        data: {
          page_num: this.pageNum,
          page_size: 6,
          work_team_id: '6',
          work_status: 2
        }
      }, (r) => {
        if (r.code) {
          this.total = r.data.total
          this.worksList = this.worksList.concat(r.data.items)
          this.$.s('worksList', this.$.o2s(this.worksList))
          if (isFirst) {
            this.loading = false
          }
        }
      })
    },
    /**
     * 查看详情
    */
    viewItem (val) {
      let routeUrl = this.$router.resolve({
        path: '/works/' + val.id
      })
      window.open(routeUrl.href, '_blank')
    },
    /**
    * 显示更多
    */
    seeMoreVisible (isVisible, entry) {
      if (isVisible) {
        entry.target.style.bottom = '40px'
        entry.target.style.opacity = '1'
      }
    },
    /**
    * 封面图片
    */
    visibilityChanged (isVisible, entry) {
      if (isVisible) {
        entry.target.firstElementChild.style.height = '100%'
      }
    },
    /**
    * 滚动偏移计算
    */
    offsetBottom (idx) {
      let res = ''
      if (idx % 2 === 1) {
        res = 'bottom: ' + (this.scrollHeight * 7 - 100) + 'px'
      } else {
        res = 'bottom: ' + this.scrollHeight * 2 + 'px'
      }
      if (idx === 'more') {
        res = 'bottom: ' + this.scrollHeight * 3 + 'px'
      }
      return res
    }
  }
}
</script>
<style>
.work-items-more {
  font-size: 1.625em;
  font-weight: 600;
}
.work-items-title {
  font-size: 1.8em;
  font-weight: 600;
  margin-bottom: 6px;
}
.work-items-item {
  height: 25em;
  margin-bottom: 4em;
}
.work-items-tags {
  font-size: 0.875em;
}
.works-items-title-box {
  bottom: 1.5em;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .work-items-title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 6px;
  }
  .work-items-item {
    height: 400px;
    margin-bottom: 90px;
  }
  .work-items-tags {
    font-size: 15px;
  }
  .works-items-title-box {
    bottom: 28px;
  }
  .work-items-more {
    font-size: 28px;
    font-weight: 600;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .work-items-title {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 6px;
  }
  .work-items-item {
    height: 500px;
    margin-bottom: 100px;
  }
  .work-items-tags {
    font-size: 15px;
  }
  .works-items-title-box {
    bottom: 40px;
  }
  .work-items-more {
    font-size: 32px;
    font-weight: 600;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .work-items-title {
    font-size: 38px;
    font-weight: 600;
    margin-bottom: 6px;
  }
  .work-items-item {
    height: 600px;
    margin-bottom: 110px;
  }
  .work-items-tags {
    font-size: 16px;
  }
  .works-items-title-box {
    bottom: 50px;
  }
  .work-items-more {
    font-size: 38px;
    font-weight: 600;
  }
}
@media screen and (min-width: 1920px) {
  .work-items-title {
    font-size: 46px;
    font-weight: 600;
    margin-bottom: 6px;
  }
  .work-items-item {
    height: 700px;
    margin-bottom: 120px;
  }
  .work-items-tags {
    font-size: 16px;
  }
  .works-items-title-box {
    bottom: 60px;
  }
  .work-items-more {
    font-size: 46px;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/workItems.vue